// extracted by mini-css-extract-plugin
module.exports = {"authText":"authText--gJSxM","forgotCaption":"forgotCaption--oxF2s","forgotContact":"forgotContact--vPmt8"};